import { CombinedError } from "@urql/vue";
import * as Sentry from "@sentry/vue";
import { AppIdentifier } from "@/shared/@types/AppIdentifier";
import { translateError } from "./translateError.helper";
import { MAINTENANCE_ERROR_MSG } from "./errorConstants.helper";

export const handleCombinedError = (error: CombinedError | undefined) => {
  if (error instanceof CombinedError) {
    if (error && error.graphQLErrors.length > 0) {
      const combinedError = error.graphQLErrors[0];
      // Maintenance
      // @ts-expect-error: TODO: This new error showed up after updating @vue/tsconfig. Examine if this is really an issue (or `?` or `!` can be applied easily)
      if (combinedError.message === MAINTENANCE_ERROR_MSG) {
        window.location.href = `/${AppIdentifier.Maintenance}`;
        return undefined;
      }
      // Internal Error
      Sentry.captureMessage(
        // @ts-expect-error: TODO: This new error showed up after updating @vue/tsconfig. Examine if this is really an issue (or `?` or `!` can be applied easily)
        `Unexpected GraphQL-Error: ${combinedError.path?.join("-")}`,
        { extra: { message: error.message } },
      );
    }
    // Network Error
    if (error && error.networkError) {
      Sentry.captureException(error.networkError);
    }
    return translateError("INTERNAL_ERROR");
  }
  return undefined;
};
